import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query PrinterDevices($branchID: ID!) {
    printerDevices(branchID: $branchID) {
      id
      name
    }
  }
`);

export default function usePrinterDevices(branchID: string) {
  return useQuery(QUERY, {
    variables: {
      branchID,
    },
  });
}
